// extracted by mini-css-extract-plugin
export var container = "RightSideRssFeedList-module--container--t57LZ";